// extracted by mini-css-extract-plugin
export var active = "_2j-b";
export var activeIndicator = "_2j-6";
export var animate = "_2j-a";
export var disabled = "_2j-c";
export var flat = "_2j-1";
export var fullWidth = "_2j-3";
export var lg = "_2j-9";
export var md = "_2j-8";
export var redoButtonTabGroup = "_2j-0";
export var sm = "_2j-7";
export var tabButton = "_2j-4";
export var tabButtonsContainer = "_2j-2";
export var xs = "_2j-5";